module.exports = __webpack_public_path__ + "static/media/TIME.81469014.png";